/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { themeToken } from '../../utils/cpds-utils';
import { mediaQueryVals } from 'components/common/cpds/token/shared/common';

/* Note: By default, this component is rendered as a 'div' element.
If your use case requires a different HTML element, please update the component accordingly.
Get the the token please use cpds props ex: ${cpds?.button_primary_background_color}

Start styles for component here
Your Styles goes here
End styles for component here

Styles overrides - Do not Remove This Code Block
Data feed styles overrides goes here

// Your Styles goes here and use token ex: ${token?.button_primary_background_color}
*/
export enum BackgroundVariant {
  DARK_PRIMARY = 'dark primary',
  DARK_SECONDARY = 'dark secondary',
  LIGHT = 'light',
}

const playIcon = {
  large: {
    width: '80px',
    height: '80px',
  },
  small: {
    width: '40px',
    height: '40px',
  },
};

const getColorPalette = (style: string, token) => {
  return {
    defaultBorder:
      token?.[
        `video_play_button_${
          style ? style.toLowerCase().replaceAll(' ', '_') : BackgroundVariant.LIGHT
        }_default_border_color`
      ] || '#191E3B',
    defaultArrow:
      token?.[
        `video_play_button_${
          style ? style.toLowerCase().replaceAll(' ', '_') : BackgroundVariant.LIGHT
        }_default_arrow_color`
      ] || '#191E3B',
    hoverBorder:
      token?.[
        `video_play_button_${
          style ? style.toLowerCase().replaceAll(' ', '_') : BackgroundVariant.LIGHT
        }_hover_border_color`
      ] || '#191E3B',
    hoverArrow:
      token?.[
        `video_play_button_${
          style ? style.toLowerCase().replaceAll(' ', '_') : BackgroundVariant.LIGHT
        }_hover_arrow_color`
      ] || '#FFFFFF',
    disabledBorder:
      token?.[
        `video_play_button_${
          style ? style.toLowerCase().replaceAll(' ', '_') : BackgroundVariant.LIGHT
        }_disabled_border_color`
      ] || '#E2E4EC',
    disabledArrow:
      token?.[
        `video_play_button_${
          style ? style.toLowerCase().replaceAll(' ', '_') : BackgroundVariant.LIGHT
        }_disabled_arrow_color`
      ] || '#9CA0B0',
    focusBorder:
      token?.[
        `video_play_button_${
          style ? style.toLowerCase().replaceAll(' ', '_') : BackgroundVariant.LIGHT
        }_focus_border_color`
      ] || '#191E3B',
    focusOuterBorder:
      token?.[
        `video_play_button_${
          style ? style.toLowerCase().replaceAll(' ', '_') : BackgroundVariant.LIGHT
        }_focus_outer_border_color`
      ] || '#191E3B',
    focusArrow:
      token?.[
        `video_play_button_${
          style ? style.toLowerCase().replaceAll(' ', '_') : BackgroundVariant.LIGHT
        }_focus_arrow_color`
      ] || '#191E3B',
  };
};

export const PlayButton = styled.button`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      width: ${playIcon.large.width};
      height: ${playIcon.large.height};
      transition: opacity 0.5s ease-in-out, background-color 0.5s ease-in-out;
      opacity: ${(props) => (props.visible ? 1 : 0)};
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      border: 4px solid ${(props) => getColorPalette(props.colorVariant, token).defaultBorder};

      .cpds-icon {
        path {
          transition: fill 0.5s ease-in-out;
          fill: ${(props) => getColorPalette(props.colorVariant, token).defaultArrow};
        }
      }

      @media (max-width: ${mediaQueryVals.cpds_small_upper_limit}) {
        width: ${playIcon.small.width};
        height: ${playIcon.small.height};
        border: 2px solid ${(props) => getColorPalette(props.colorVariant, token).defaultBorder};
      }

      &:hover {
        opacity: 1;
        border: 4px solid ${(props) => getColorPalette(props.colorVariant, token).hoverBorder};
        background-color: ${(props) => getColorPalette(props.colorVariant, token).hoverBorder};

        .cpds-icon {
          path {
            fill: ${(props) => getColorPalette(props.colorVariant, token).hoverArrow};
          }
        }

        @media (max-width: ${mediaQueryVals.cpds_small_upper_limit}) {
          border: 2px solid ${(props) => getColorPalette(props.colorVariant, token).hoverBorder};
        }
      }

      &:focus-visible {
        border: 4px solid ${(props) => getColorPalette(props.colorVariant, token).focusBorder};
        background-color: transparent;
        outline: none;

        &.cpds-icon {
          path {
            fill: ${(props) => getColorPalette(props.colorVariant, token).focusArrow};
          }
        }

        @media (max-width: ${mediaQueryVals.cpds_small_upper_limit}) {
          border: 2px solid ${(props) => getColorPalette(props.colorVariant, token).focusBorder};
        }

        &:before {
          content: '';
          position: absolute;
          border: 1px dashed ${(props) => getColorPalette(props.colorVariant, token).focusOuterBorder};
          border-radius: inherit;
          pointer-events: none;
          opacity: 1;
          top: -8px;
          left: -8px;
          right: -8px;
          bottom: -8px;
        }
      }

      &:disabled {
        border: 4px solid ${(props) => getColorPalette(props.colorVariant, token).disabledBorder};
        background-color: transparent;
        cursor: not-allowed;

        .cpds-icon {
          path {
            fill: ${(props) => getColorPalette(props.colorVariant, token).disabledArrow};
          }
        }

        @media (max-width: ${mediaQueryVals.cpds_small_upper_limit}) {
          border: 2px solid ${(props) => getColorPalette(props.colorVariant, token).focusBorder};
        }
      }

      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export const Overlay = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    playerState,
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      ${playerState === 0 || playerState === 2
        ? `
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: ${playIcon.large.width};
          height: ${playIcon.large.height};
          @media (max-width: ${mediaQueryVals.cpds_small_upper_limit}) {
            width: ${playIcon.small.width};
            height: ${playIcon.small.height};
          }
        `
        : ''}

      &:hover {
        ${PlayButton} {
          opacity: 1;
        }
      }

      ${({ disabled }) =>
        disabled &&
        `
        pointer-events: none;
      `}

      ${(props) => props?.styleOverrides}
    `;
  }}
`;
